<template lang="pug">
ul
  li
    a.sub-menu-btn.card-expanded(data-bs-toggle='collapse' href='#sport' role='button' aria-expanded='false' aria-controls='sport')
      ThemeImage.icon-inactive(src='images/light/game-type/all-sport.svg' alt='')
      ThemeImage.icon-active(src='images/light/game-type/all-sport-active.svg' alt='')
      |  {{ $t("ui.all_sports") }}
      span.arrow
    ul#sport.sub-menu.active.collapse.show
      template(v-if="menu1 == 'mmoparlay'")
        li.active
          a(href='index.html')
            span.sport-name
              ThemeImage.icon(src='images/light/sport/blue/1.svg' alt='')
              .sport-name-text  {{ $t("ui.soccer") }}
            //- span.event-count 12   
      template(v-else)
        template(v-for="n in order")
          li(:key="n" v-if="items[n]" @click="setMenu2(n)")
            a(href='javascript:void(0);' :class="{ 'active' : selectedSportType == n }") 
              span.sport-name
                ThemeImage.icon(:src="'/images/light/sport/blue/' + n + '.svg?v=12'" alt='')
                .sport-name-text  {{ sports[n] }}
              span.event-count {{ totalCount(n) }}

</template>

<script>
import config from "@/config";

export default {
  props: {
    mode: {
      type: Number 
    },
    live: {
      type: Object,
      default: () => []
    },
    today: {
      type: Object,
      default: () => []
    },
    early: {
      type: Object,
      default: () => []
    },
    order: {
      type: Array,
      default: () => []
    },
    items: {
      type: Object,
      default: () => {}
    },
    sports: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      options: {}
    };
  },
  computed: {
    selectedSportType() {
      return this.menu2;
    },
    menu1() {
      return this.$store.getters.menu1;
    },
    menu2() {
      return this.$store.getters.menu2;
    }
  },
  mounted() {
    this.initial();
  },
  methods: {
    getSportsImage(e) {
      return e == 0 ? "all.svg?v=12" : config.getSportsImage(e);
    },
    initial() {
      var sportsList = Object.keys(this.items);
      if (!sportsList.includes(this.menu2.toString())) {
        if (sportsList.length > 0) {
          var x = sportsList[0];
          if(this.mode) {
            this.showSelected(x);
          }
        }
      }
    },
    showSelected(e) {
      // console.log(e);
      this.$emit("setMenu2", e);
      // var mi5 = {};
      // mi5["menuX"] = false;
      // mi5["menuY"] = "0";
      // mi5["menu0"] = this.menu0;
      // mi5["menu1"] = this.menu1;
      // mi5["menu2"] = parseInt(e);      
      // mi5["menu3"] = this.menu3;
      // for (var n in this.options) {
      //   this.options[n] = false;
      // }
      // this.options[e] = true;
      // this.$emit("save", Object.assign({}, this.options));
      // this.$store.dispatch("layout/setMenuItems", mi5);
      // EventBus.$emit("INVALIDATE", mi5);
    },
    setMenu2(e) {
      this.$emit("setMenu2", e);
    },
    totalCount(e) {
      let count = 0;
      if (this.live[e] && this.live[e].tn > 0) {
        count += this.live[e].tn;
      }
      if (this.today[e] && this.today[e].tn > 0) {
        count += this.today[e].tn;
      }
      if (this.early[e] && this.early[e].tn > 0) {
        count += this.early[e].tn;
      }
      return count;
    }
  }
};
</script>
